/**
 * MSAL (Microsoft Authentication Library) Configuration
 * 
 * Azure AD App Registration Details:
 * - Frontend SPA Client ID: b105e26c-fec1-4072-959a-88989663d885
 * - Backend API Client ID: 43a1b855-597c-44d2-bcaa-11f93be9df24
 * - Tenant ID: 7bb63ee7-a3e1-4d75-b5a5-6f9549f171a3
 */

export const msalConfig = {
  auth: {
    clientId: "b105e26c-fec1-4072-959a-88989663d885", // Frontend SPA Client ID
    authority: "https://login.microsoftonline.com/7bb63ee7-a3e1-4d75-b5a5-6f9549f171a3", // Tenant ID
    redirectUri: window.location.origin, // Will be http://localhost:3000 in dev, production URL in prod
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // Store tokens in localStorage
    storeAuthStateInCookie: false, // Set to true for IE11/Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case "Error":
            console.error(message);
            return;
          case "Info":
            console.info(message);
            return;
          case "Verbose":
            console.debug(message);
            return;
          case "Warning":
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes for access token request
 * This requests access to the backend API with the custom scope
 */
export const loginRequest = {
  scopes: ["api://43a1b855-597c-44d2-bcaa-11f93be9df24/access_as_user"], // Backend API scope
};

/**
 * Scopes for silent token acquisition (refresh)
 */
export const tokenRequest = {
  scopes: ["api://43a1b855-597c-44d2-bcaa-11f93be9df24/access_as_user"],
  forceRefresh: false, // Set to true to skip cache and get new token
};

/**
 * Optional: Microsoft Graph scopes if you need user profile info
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
